<script>
  import ListHeader from '../../../../components/list/Header.vue'

  import * as restfulService from '../../../../services/restfulService'

  import bus from '@utils/bus'

  import {cloneDeep, orderBy} from 'lodash'
  import {Chart} from 'highcharts-vue'

  export default {
    components: {ListHeader, highcharts: Chart},
    data () {
      return {
        activeTab: 'registration_list',
        searchAppraiser: '',
        reports: {
          registrations_list: [],
          registrations: [],
          events: [],
          modalities: [],
          papers_review: []
        },
        chartPieOptions: {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: null,
            plotShadow: false,
            type: 'pie'
          },
          title: {text: ''},
          tooltip: {pointFormat: '{series.name}: <b>{point.y}</b>'},
          plotOptions: {
            pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y}',
                style: {
                  color: 'black'
                }
              }
            }
          },
          series: [{
            name: '',
            colorByPoint: true,
            data: []
          }]
        },
        chartSemiCircleOptions: {
          chart: {
            plotBackgroundColor: null,
            plotBorderWidth: 0,
            plotShadow: false
          },
          title: {text: ''},
          tooltip: {
            pointFormat: '{series.name}: <b>{point.y}</b>'
          },
          plotOptions: {
            pie: {
              dataLabels: {
                enabled: true,
                format: '<b>{point.name}</b>: {point.y}',
                distance: -50,
                style: {
                  fontWeight: 'bold',
                  color: 'white'
                }
              }
            }
          },
          series: [{
            type: 'pie',
            name: '',
            innerSize: '20%',
            data: []
          }]
        }
      }
    },
    computed: {
      pageTitle: function () {
        return 'Relatórios'
      },
      totalRegistrations: function () {
        let total = 0
        this.reports.registrations.forEach(item => {
          total += item.total
        })
        return total
      },
      totalAmountRegistrations: function () {
        let total = 0
        this.reports.registrations.forEach(item => {
          total += item.total_amount
        })
        return total
      },
      papersReviewList: function () {
        return orderBy(this.reports.papers_review.filter(item => item.name.toLowerCase().includes(this.searchAppraiser.toLowerCase())), ['total'], ['desc'])
      }
    },
    mounted () {
      const id = this.$route.params.id || null
      if (id) {
        restfulService.get('event', 'reports/dashboard', id)
          .then(response => {
            this.reports = response
            bus.$emit('hide-loader')
          })
          .catch((err) => {
            console.log(err)
            bus.$emit('hide-loader')
          })
      } else {
        bus.$emit('hide-loader')
      }
    },
    methods: {
      mountChartPieOptions (items) {
        let chartPieOptions = cloneDeep(this.chartPieOptions)
        chartPieOptions.series.splice(0)
        chartPieOptions.series.push({
          name: 'Total de Inscritos',
          colorByPoint: true,
          data: []
        })
        items.forEach(item => {
          chartPieOptions.series[0].data.push({
            name: item.literacy_name,
            y: item.total
          })
        })
        return chartPieOptions
      },
      mountChartSemiCircleOptions (items) {
        let chartSemiCircleOptions = cloneDeep(this.chartSemiCircleOptions)
        chartSemiCircleOptions.series.splice(0)
        chartSemiCircleOptions.series.push({
          type: 'pie',
          name: 'Total de Inscritos',
          innerSize: '50%',
          data: []
        })
        items.forEach(item => {
          chartSemiCircleOptions.series[0].data.push({
            name: item.status_name,
            y: item.total
          })
        })
        return chartSemiCircleOptions
      }
    }
  }
</script>

<template>
    <div>
        <ListHeader :title="pageTitle" back-route="event.index"/>

        <el-tabs type="card" v-model="activeTab">
            <el-tab-pane name="registration_list" label="Lista de Inscrições">
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>Cód. Inscrição</th>
                        <th>Ref. Pessoa</th>
                        <th>Nome</th>
                        <th>Email</th>
                        <th>Telefone</th>
                        <th>Instituição</th>
                        <th>Modalidades</th>
                        <th>Valor</th>
                        <th>Vencimento</th>
                        <th>Pago</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in reports.registrations_list.list">
                        <td>{{item.id}}</td>
                        <td>{{item.ref_pessoa}}</td>
                        <td>{{item.nome}}</td>
                        <td>{{item.email}}</td>
                        <td>{{item.phone}}</td>
                        <td>{{item.institution}}</td>
                        <td>{{item.modalities}}</td>
                        <td>{{item.amount}}</td>
                        <td>{{item.due_date}}</td>
                        <td>{{item.pago ? 'Sim' : 'Não'}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="registrations" label="Inscrições por Situação de Pagamento">
                <table class="custom-table-list reports-table-status">
                    <tbody>
                    <tr>
                        <td>
                            <div>Total</div>
                            <div>{{totalRegistrations}}</div>
                        </td>
                        <td v-for="item in reports.registrations">
                            <div>{{item.status_name}}</div>
                            <div>{{item.total}}</div>
                        </td>
                    </tr>
                    <tr>
                        <td>
                            <div>R$ {{totalAmountRegistrations | currencyEnToBr}}</div>
                        </td>
                        <td v-for="item in reports.registrations">
                            <div>R$ {{item.total_amount | currencyEnToBr}}</div>
                        </td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
            <el-tab-pane name="events" label="Inscrições por Evento">
                <div class="modalities-list">
                    <div class="modality-items">
                        <div v-for="(item, index) in reports.events" class="modality-item --small">
                            <h4>{{item.event_title}}</h4>
                            <div>
                                <highcharts :key="index" :options="mountChartSemiCircleOptions(item.registrations)"/>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="modalities" label="Participantes por Modalidade">
                <div class="modalities-list">
                    <div class="modality-items">
                        <div v-for="(items, index) in reports.modalities" class="modality-item">
                            <h4>{{items[0].modality_name}}</h4>
                            <div>
                                <highcharts :key="index" :options="mountChartPieOptions(items)"/>
                            </div>
                        </div>
                    </div>
                </div>
            </el-tab-pane>
            <el-tab-pane name="papers_review" label="Trabalhos por Avaliador">
                <table class="custom-table-list">
                    <thead>
                    <tr>
                        <th>Avaliador</th>
                        <th>Graduação</th>
                        <th>Instituição</th>
                        <th>Total de Avaliações</th>
                    </tr>
                    <thead>
                    <tr>
                        <th colspan="4">
                            Pesquisar Avaliador:
                            <input type="text" v-model="searchAppraiser">
                        </th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="item in papersReviewList">
                        <td>{{item.name}}</td>
                        <td>{{item.grade}}</td>
                        <td>{{item.institution}}</td>
                        <td>{{item.total}}</td>
                    </tr>
                    </tbody>
                </table>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<style lang="scss">
    .report-block {
        margin-bottom: 65px;
    }

    .reports-table-status {
        td {
            padding: 20px;
            div {
                text-align: center;
                font-size: 22px;
                &:nth-child(2) {
                    font-weight: bold;
                    font-size: 32px;
                }
            }
            &.sub-table {
                padding: 0;
                border: 0;
                .custom-table-list {
                    margin: 0;
                }
                td {
                    padding: 10px;
                    div {
                        text-align: center;
                        font-size: 16px;
                        &:nth-child(2) {
                            font-weight: bold;
                            font-size: 22px;
                        }
                    }
                }
            }
        }
    }

    .modalities-list {
        .modality-items {
            display: flex;
            flex-wrap: wrap;
            justify-content: space-around;
            .modality-item {
                width: 48%;
                margin-bottom: 80px;
                border: 1px solid #f2f2f2;
                &.--small {
                    width: 16%;
                }
                h4 {
                    padding: 10px;
                    background-color: #f2f2f2;
                    text-align: center;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// Reports.vue?7c190ec8